import React from "react"

export const ODONTOFLOW_BRAND = {
  navy: "#0B1A3A",
  blue: "#1064FF",
  cyan: "#22C1FF",
  violet: "#7A5AF8",
  lavender: "#B084FF",
  teal: "#21C981",
  light: "#F2F4F7",
  white: "#FFFFFF",
}

const SIZE_MAP = {
  xs: { icon: 24, logoHeight: 28 },
  sm: { icon: 30, logoHeight: 34 },
  md: { icon: 40, logoHeight: 44 },
  lg: { icon: 54, logoHeight: 58 },
  xl: { icon: 66, logoHeight: 76 },
}

const BRAND_ASSETS = {
  horizontal: {
    color: "/brand/odontoflow-logo-horizontal-color.png",
    dark: "/brand/odontoflow-logo-horizontal-dark.png",
    black: "/brand/odontoflow-logo-horizontal-black.png",
    gradient: "/brand/odontoflow-logo-horizontal-gradient.png",
  },
  isotipo: {
    color: "/brand/odontoflow-isotipo-color.png",
    dark: "/brand/odontoflow-isotipo-dark.png",
    black: "/brand/odontoflow-isotipo-black.png",
    gradient: "/brand/odontoflow-isotipo-gradient.png",
  },
  appIcon: "/brand/odontoflow-app-icon.png",
}

function resolveAssetMode({ theme, assetMode }) {
  if (assetMode === "black") return "black"
  if (assetMode === "gradient") return "gradient"
  if (theme === "dark") return "dark"
  return "color"
}

function getLogoSrc({ theme, appIcon, iconOnly, assetMode }) {
  if (appIcon) return BRAND_ASSETS.appIcon

  const resolvedMode = resolveAssetMode({ theme, assetMode })

  if (iconOnly) {
    return BRAND_ASSETS.isotipo[resolvedMode] || BRAND_ASSETS.isotipo.color
  }

  return BRAND_ASSETS.horizontal[resolvedMode] || BRAND_ASSETS.horizontal.color
}

export default function OdontoFlowLogo({
  variant = "horizontal",
  theme = "light",
  assetMode = "default",
  size = "md",
  showText = true,
  showDescriptor = false,
  descriptor = "Gestión odontológica clara y fluida.",
  appIcon = false,
  style,
  className,
  imgStyle,
}) {
  const sizing = SIZE_MAP[size] || SIZE_MAP.md
  const iconOnly = variant === "icon" || !showText || appIcon

  const src = getLogoSrc({
    theme,
    appIcon,
    iconOnly,
    assetMode,
  })

  if (iconOnly) {
    return (
      <span
        className={className}
        style={{
          width: sizing.icon,
          height: sizing.icon,
          display: "inline-grid",
          placeItems: "center",
          flex: "0 0 auto",
          overflow: "hidden",
          borderRadius: appIcon ? Math.round(sizing.icon * 0.24) : 0,
          ...style,
        }}
      >
        <img
          src={src}
          alt="OdontoFlow"
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            objectFit: "contain",
            ...imgStyle,
          }}
        />
      </span>
    )
  }

  return (
    <div
      className={className}
      style={{
        display: "inline-grid",
        gap: showDescriptor ? 5 : 0,
        minWidth: 0,
        maxWidth: "100%",
        overflow: "hidden",
        ...style,
      }}
    >
      <img
        src={src}
        alt="OdontoFlow"
        style={{
          height: sizing.logoHeight,
          width: "auto",
          maxWidth: "100%",
          display: "block",
          objectFit: "contain",
          ...imgStyle,
        }}
      />

      {showDescriptor ? (
        <div
          style={{
            color: theme === "dark" ? "rgba(226,232,240,0.76)" : "#64748b",
            fontSize: Math.max(11, Math.round(sizing.logoHeight * 0.23)),
            fontWeight: 750,
            letterSpacing: "0.01em",
            lineHeight: 1.25,
            whiteSpace: "normal",
            overflowWrap: "break-word",
            maxWidth: "100%",
          }}
        >
          {descriptor}
        </div>
      ) : null}
    </div>
  )
}